import React from 'react';
import { Route, IndexRoute } from 'react-router';
import ReferralDashboard from './ReferralDashboard';

export default (
  <Route path="indique-e-ganhe">
    <IndexRoute component={(props) => <ReferralDashboard {...props} />} />
  </Route>
);
